import React from 'react';

import { Icon } from '../Icon';
import { BreadcrumbProps } from './breadcrumb.types';
import * as S from './breadcrumb.styles';

import ChevronRight from '@/icons/chevron_right.icon.svg';

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ history, navigateFn }) => {
  const currentUrl = window.location.pathname;
  return (
    <S.BreadCrumbContainer>
      {history.map((item, idx) => {
        const isCurrent = item.url === currentUrl;

        return (
          <React.Fragment key={idx}>
            {idx !== 0 && (
              <S.ChevronContainer>
                <Icon icon={ChevronRight} />
              </S.ChevronContainer>
            )}
            <S.Label isCurrent={isCurrent} onClick={() => navigateFn(item.url)}>
              {item.label}
            </S.Label>
          </React.Fragment>
        );
      })}
    </S.BreadCrumbContainer>
  );
};
